/** `01/15/1990`. Shape only — `99/99/1990` matches too. */
export const DATE_MM_DD_YYYY_PATTERN = /^\d{2}\/\d{2}\/\d{4}$/;

/** `user@example.com`, plus quoted local parts and `user@[192.168.1.1]`. */
export const EMAIL_ADDRESS_PATTERN =
  // eslint-disable-next-line security/detect-unsafe-regex
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;

/** `2026-01-15T10:30:00.123Z`. At most three fractional digits. */
export const ISO_8601_DATE_TIME_PATTERN =
  // eslint-disable-next-line security/detect-unsafe-regex
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})$/;

/** `2026-01-15T10:30:00.123456Z`. Any number of fractional digits. */
export const ISO_8601_DATE_TIME_LENIENT_PATTERN =
  // eslint-disable-next-line security/detect-unsafe-regex
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,})?(Z|[+-]\d{2}:\d{2})$/;

/**
 * One name part: `Mary Jane`, `O'Brien`, `Smith-Jones`.
 * ASCII only, so `José` is rejected.
 */
export const PERSON_NAME_PATTERN = /^[a-zA-Z\s-']+$/;

/** `9872543210` or `987-254-3210`, under NANP area and exchange rules. */
export const PHONE_NUMBER_PATTERN =
  /^(?:[2-9]\d{2}[2-9]\d{6}|[2-9]\d{2}-[2-9]\d{2}-\d{4})$/;

/** Also takes `19872543210`, `987.254.3210` and `987 254 3210`. */
export const PHONE_NUMBER_LENIENT_PATTERN =
  /^1?(?:[2-9]\d{2}[2-9]\d{6}|[2-9]\d{2}[-. ][2-9]\d{2}[-. ]\d{4})$/;

/** `123-45-6789` or `123456789`, where punctuation is not yours to control. */
export const SSN_PATTERN = /^(?:\d{3}-\d{2}-\d{4}|\d{9})$/;

/** `123-45-6789` only — what the UI's masked input produces. */
export const SSN_DASHED_PATTERN = /^\d{3}-\d{2}-\d{4}$/;

/**
 * `3f2a1b4c-5d6e-4f70-8a9b-0c1d2e3f4a5b`, in either case. Any version or
 * variant, so it also accepts ids that did not come from `uuid`'s `v4()`.
 */
export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
